import React from 'react';

type AlertProps = {
  message: string;
  onDismiss: () => void;
};

export default function Alert({ message, onDismiss }: AlertProps) {
  return (
    <div
      className="mb-6 flex items-center justify-between gap-4 rounded-md border border-green-700 bg-green-900/30 px-4 py-3 text-green-200"
      role="alert"
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={onDismiss}
        className="shrink-0 rounded p-1 text-green-300 hover:bg-green-800/50 hover:text-white focus:outline-none focus:ring-2 focus:ring-green-500"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
